export const blurDataURL =
  'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTIgNTIiIHdpZHRoPSIxODAiIGhlaWdodD0iMTgwIiB2aWV3Qm94LXVpZD0iNzEiIGZpbGw9IiMwMDAwMDAiLz4=';
